import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { Card } from '../../components/ui/Card';
import { useLocale } from '../../contexts/LocaleContext';
import type { Locale } from '../../types';
const languageNames: Record<Locale, string> = {
  'pt-BR': 'Português (Brasil)',
  'en-US': 'English'
};
type Choice = 'system' | Locale;
export function LanguageSettings() {
  const {
    t,
    locale,
    source,
    setLocale,
    followSystemLocale,
    systemLocale
  } = useLocale();
  const options: {
    id: Choice;
    label: string;
    hint: string;
  }[] = [{
    id: 'system',
    label: t('language.system'),
    hint: t('language.systemHint', {
      lang: languageNames[systemLocale]
    })
  }, {
    id: 'pt-BR',
    label: languageNames['pt-BR'],
    hint: 'pt-BR'
  }, {
    id: 'en-US',
    label: languageNames['en-US'],
    hint: 'en-US'
  }];
  const selectedChoice: Choice = source === 'system' ? 'system' : locale;
  return <div className="px-2 pb-2" data-id="element-3876" data-mp="3pq9z81tc1ocy">
      <PageHeader title={t('settings.language')} subtitle={t('language.subtitle')} showBack data-id="element-3877" data-mp="2qnlhrj210su0" />

      <Card className="px-2" data-id="element-3878" data-mp="2lpjx4toyclgf">
        <ul role="radiogroup" aria-label={t('settings.language')} data-id="element-3879" data-mp="2loibxwe82ikz">
          {options.map(option => {
          const selected = selectedChoice === option.id;
          return <li key={option.id} className="border-b border-sand-line last:border-b-0" data-id="element-3880" data-mp="2vfv6wwvbhov8">
                <button type="button" role="radio" aria-checked={selected} onClick={() => option.id === 'system' ? followSystemLocale() : setLocale(option.id)} className="flex min-h-[56px] w-full items-center gap-2 py-2 text-left" data-id="element-3881" data-mp="27pseugrekiwm">
                  <span className="min-w-0 flex-1" data-id="element-3882" data-mp="3s2zsot4zeqh8">
                    <span className="block text-[13.5px] font-medium text-deep" data-id="element-3883" data-mp="3n69fcdkka8zi">
                      {option.label}
                    </span>
                    <span className="mt-[2px] block text-[11px] text-muted" data-id="element-3884" data-mp="2ks22z9c2kdef">
                      {option.hint}
                    </span>
                  </span>
                  <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-pill border ${selected ? 'border-gold bg-gold text-deep' : 'border-deep/25'}`} data-id="element-3885" data-mp="2tsrqlpr6exh2">
                    {selected && <CheckIcon size={14} strokeWidth={3} data-id="element-3886" data-mp="263fbyad2xx7d" />}
                  </span>
                </button>
              </li>;
        })}
        </ul>
      </Card>

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-3887" data-mp="2b17b9pg20lll">
        {t('language.note')} {t('language.manualNote')}
      </p>
    </div>;
}